import { log } from '../../services/utils';

import { noraApiRequest } from '.';

import { controller } from '../../contexts/SubmissionsContext'; // uses submission context

export const getEvaluation = async id => {
	log( '* get evaluation' );
	const response = await noraApiRequest( {
		signal: controller.signal,
		url: `/eval/documentSubmission/${ id }`
	} );

	return response.data;
};

export const saveEval = async ( id, data ) => {
	log( '* save evaluation' );
	const response = await noraApiRequest( {
		method: 'POST',
		data,
		signal: controller.signal,
		url: `/eval/documentSubmission/${ id }/tracking`
	} );

	return response.data;
};
